// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'amex',
  icon: [
    31,
    19,
    null,
    null,
    null,
    <g id="amex" fillRule="nonzero" key="amex">
      <path
        d="M27.58,19 L3.42,19 C2.78347383,19.0053265 2.17090452,18.7575644 1.71706166,18.311223 C1.26321879,17.8648817 1.00528228,17.2565265 1,16.62 L1,2.38 C1.00528228,1.74347346 1.26321879,1.13511831 1.71706166,0.688776978 C2.17090452,0.242435646 2.78347383,-0.00532648787 3.42,4.4408921e-16 L27.58,4.4408921e-16 C28.2165262,-0.00532648787 28.8290955,0.242435646 29.2829383,0.688776978 C29.7367812,1.13511831 29.9947177,1.74347346 30,2.38 L30,16.63 C29.9835257,17.9515828 28.9016388,19.0111167 27.58,19 Z"
        id="shape"
        fill="#1D91CE"
      />
      <polyline
        id="shape"
        fill="#FFFFFF"
        points="5.063 11.896 4.591 13 0.36 13 3.699 6 11.674 6 12.479 7.546 13.231 6 16.064 6 17.492 6 23.983 6 24.902 6.961 25.889 6 30.882 6 27.337 9.492 30.729 13 25.897 13 24.816 11.969 23.744 13 17.492 13 16.064 13 6.496 13 5.977 11.896"
      />
      <path
        d="M5.98,11.97 L5.06,11.97 L5.98,11.97 Z M16.2,7 L14.1,7 L12.52,10.35 L10.82,7 L8.72,7 L8.72,11.85 L6.55,7 L4.58,7 L2.26,12 L3.68,12 L4.15,10.86 L6.85,10.86 L7.39,12 L10,12 L10,7.93 L11.85,12 L13.07,12 L14.91,8 L14.91,12 L16.2,12 L16.2,7 Z M24.87,8.62 L23.37,7 L17.35,7 L17.35,12 L23.17,12 L24.82,10.36 L26.48,12 L28.03,12 L25.66,9.47 L28.1,7 L26.48,7 L24.87,8.62 L24.87,8.62 Z M21.7,11 L18.64,11 L18.64,9.9 L21.7,9.9 L21.7,8.9 L18.64,8.9 L18.64,8 L21.7,8 L21.7,7.15 L23.97,9.42 L21.7,11.7 L21.7,11 Z M5.53,7.82 L6.41,9.85 L4.58,9.85 L5.53,7.82 Z"
        id="shape"
        fill="#1D91CE"
      />
    </g>,
  ],
})
